"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const InputContext_1 = require("../../contexts/InputContext");
function getValueLength(val) {
    if (val === undefined || val === null) {
        return 0;
    }
    return `${val}`.length;
}
/*
* This will setup state for the FieldLabel
* Remember, InputLabel doesnt HAVE to have a form.
* */
function useLabelRetract(inputEle, value) {
    const { placeholder } = react_1.useContext(InputContext_1.InputContext);
    const [labelRetracted, setLabelRetracted] = react_1.useState(value || !!placeholder);
    react_1.useEffect(() => {
        setLabelRetracted(getValueLength(value) > 0 || !!placeholder);
    }, [value, placeholder]);
    react_1.useEffect(() => {
        if (!inputEle) {
            return;
        }
        inputEle.addEventListener('keydown', () => {
            setLabelRetracted(true);
        });
        inputEle.addEventListener('focus', () => {
            setLabelRetracted(true);
        });
        inputEle.addEventListener('blur', (e) => {
            setLabelRetracted(!!(inputEle === null || inputEle === void 0 ? void 0 : inputEle.value) || !!placeholder);
        });
    }, [inputEle, placeholder]);
    return [labelRetracted, setLabelRetracted];
}
exports.default = useLabelRetract;
